import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';
import type { InternalProtocolSidecarStatusResponse } from '@nadoutong/contracts';
import { useSession } from '../hooks/useSession.tsx';
import { getProtocolSidecarStatus } from './protocolSidecar.ts';

export const PROTOCOL_SIDECAR_QUERY_KEY = ['protocol-sidecar'] as const;

export function useProtocolSidecarStatus(): UseQueryResult<InternalProtocolSidecarStatusResponse> {
  const { fetchImpl } = useSession();
  return useQuery({
    queryKey: PROTOCOL_SIDECAR_QUERY_KEY,
    queryFn: ({ signal }) => getProtocolSidecarStatus(fetchImpl, signal),
    refetchInterval: 60_000,
  });
}
